import { defineStore } from "pinia";
export const useComponentChangeStore = defineStore("componentChange", {
  state: () => ({
    componentValue: "mainView",
  }),
  actions: {
    changeTheComponent(componentName) {
      this.componentValue = componentName;
    },
  },
  getters: {
    getComponentName: (state) => state.componentValue,
  },
});
